module.exports = __webpack_public_path__ + "advisory-8c397925/carlos-barquero-ac3080e4f7a95a6930e971192475e8d2.jpg";